import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const MotonovoPage = () => {
  return (
    <LenderPageTemplate
      lenderName="Motonovo"
      slug="/lenders/mis-sold-motonovo-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default MotonovoPage
